import * as React from 'react';
import { Pressable, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import { Icon } from '../icon';
import { Checkmark } from '../icons/checkmark';

interface CheckboxProps {
  onPress: () => void;
  active?: boolean;
  disabled?: boolean;
}

export const Checkbox = ({
  onPress,
  active = false,
  disabled = false,
}: CheckboxProps) => {
  const { styles, theme } = useStyles(stylesheet);
  const [enabled, setEnabled] = React.useState(active);

  React.useEffect(() => {
    setEnabled(active);
  }, [active]);

  const renderCheckbox = React.useMemo(() => {
    const getTypeStyle = () => {
      let stateStyle = styles.default;

      if (disabled) {
        stateStyle = styles.disabled;
      }

      if (active) {
        stateStyle = styles.active;
      }

      return [stateStyle];
    };

    return (
      <Pressable
        style={[styles.checkbox, getTypeStyle()]}
        hitSlop={8}
        onPress={() => {
          onPress();
        }}
        disabled={disabled}
      >
        {enabled ? (
          <Icon
            type="naked"
            icon={<Checkmark />}
            fillColor={theme.colors.checkbox.iconColor}
            width={12}
            height={12}
          />
        ) : null}
      </Pressable>
    );
  }, [active, disabled, styles, onPress, enabled]);

  return <View>{renderCheckbox}</View>;
};

const stylesheet = createStyleSheet((theme) => ({
  checkbox: {
    width: 24,
    height: 24,
    borderRadius: 5,
    borderWidth: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  default: {
    backgroundColor: theme.colors.checkbox.default.backgroundColor,
    borderColor: theme.colors.checkbox.default.border,
  },
  active: {
    backgroundColor: theme.colors.checkbox.active.backgroundColor,
    borderColor: theme.colors.checkbox.active.border,
  },
  disabled: {
    backgroundColor: theme.colors.checkbox.disabled.backgroundColor,
    borderColor: theme.colors.checkbox.disabled.border,
  },
}));
